import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Drawer, Input, Space, Form, Select, InputNumber } from "antd";
import {
  DownloadOutlined,
  PlusCircleFilled,
  EditFilled,
  DeleteFilled,
} from "@ant-design/icons";

import debounce from "lodash/debounce";
import useAxios from "./../../../CustomHooks/useAxios";
import DebounceSelect from "./../../DebounceSelect";
const { TextArea } = Input;
const { Option } = Select;
const AddOutboundCallNote = ({ setVisibleCallNote }) => {
  const [form] = Form.useForm();
  return (
    <>
      
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        // initialValues={item}
        // onFinish={onFinishAdd}
        // onFinishFailed={onFinishFailedAdd}
        autoComplete="off"
      >
        <Form.Item
        label="Call Status :"
        name="code"
        rules={[{ required: true, message: 'Please input a department name!' }]}
      >
        <Input  />  
      </Form.Item>
      <Form.Item
        label="Data Status :"
        name="datastatus"
        rules={[{ required: true, message: 'Please input a department name!' }]}
      >
        <Input  />  
      </Form.Item>
      <Form.Item
        label="Call Note :"
        name="lastcallnote"
        rules={[{ required: true, message: 'Please input a department name!' }]}
      >
        <Input  />  
      </Form.Item>
      </Form>
    </>
  );
};

export default AddOutboundCallNote;
